Given the following vision integrated statements: {{integratedStatements}},
Here is the current summary: {{summary}}
Suggest improvements to make the summary vision statement clearer, more compelling, explaining why the current statement is not sufficient.
